import { FiltersType, OfferType, SearchTabs } from '@/types';

type RealMaxValues = {
  area?: number;
  roomNumber?: number;
  price?: number;
  rentPrice?: number;
};

type RealMinValues = {
  roomNumber?: number;
};

export const getFilterObject = (
  data: FiltersType,
  realMaxValues?: RealMaxValues,
  realMinValues?: RealMinValues,
) => {
  const categories = data.categoriesValue.map((category) => category.code);
  const equipment = data.equipmentValue.map((equipment) => equipment.code);
  const countries = data.unitListValue.filter((value) => value.split('.')?.length === 1);
  const division = data.unitListValue.filter((value) => value.split('.')?.length === 2);
  const districts = data.unitListValue.filter((value) => value.split('.')?.length === 3);

  const toFrom = (range: number[], realMin?: number) => {
    if (range?.length !== 2) return null;
    const v = range[0];
    if (realMin !== undefined ? v <= realMin : v === 0) return null;
    return v;
  };

  const toTo = (range: number[], realMax?: number) => {
    if (range?.length !== 2) return null;
    const v = range[1];
    if (realMax !== undefined && v >= realMax) return null;
    return v;
  };

  const spaceFrom = toFrom(data.areaValue);
  const spaceTo = toTo(data.areaValue, realMaxValues?.area);
  const roomNumberFrom = toFrom(data.roomNumberValue, realMinValues?.roomNumber);
  const roomNumberTo = toTo(data.roomNumberValue, realMaxValues?.roomNumber);
  const priceFrom = toFrom(data.priceValue);
  const priceTo = toTo(data.priceValue, realMaxValues?.price);
  const rentPriceFrom = toFrom(data.rentPriceValue);
  const rentPriceTo = toTo(data.rentPriceValue, realMaxValues?.rentPrice);
  const sorting = data.sorting?.trim().length ? data.sorting : null;
  const isMap = data.tabs === SearchTabs.MAP;
  const hasAdmunits = !!data.admunits?.length;
  const hasMapSelection = hasAdmunits || !!data.mapArea;
  const hasMapArea = !hasAdmunits && !!data.mapArea;

  const offerTypeMapping = {
    SELL: OfferType.SELL,
    RENT: OfferType.RENT,
  };

  return {
    currentPageIndex: data.currentPage,
    itemsPerPage: data.itemsPerPage,
    offerType: offerTypeMapping[data.offerTypeValue],
    categories,
    customEquips: equipment,
    countries: isMap || hasMapSelection ? [] : countries,
    division: isMap || hasMapSelection ? [] : division,
    districts: isMap || hasMapSelection ? [] : districts,
    spaceFrom,
    spaceTo,
    roomNumberFrom,
    roomNumberTo,
    priceFrom: data.offerTypeValue !== OfferType.RENT ? priceFrom : null,
    priceTo: data.offerTypeValue !== OfferType.RENT ? priceTo : null,
    rentPriceFrom: data.offerTypeValue !== OfferType.SELL ? rentPriceFrom : null,
    rentPriceTo: data.offerTypeValue !== OfferType.SELL ? rentPriceTo : null,
    powerConsumptionClasses: data.powerConsumptionClasses,
    energyClassFactors: data.energyClassFactors,
    locations: hasMapSelection ? null : data.locations?.length ? data.locations : null,
    sorting: isMap ? null : sorting,
    admunitIds: hasAdmunits ? (data.admunits?.map((a) => a.id) ?? []) : [],
    mapArea: hasMapArea ? data.mapArea : undefined,
    keywords: data.keywords || undefined,
    project: false,
  };
};

export const getProjectFilterObject = (
  data: FiltersType,
  realMaxValues?: RealMaxValues,
  realMinValues?: RealMinValues,
) => {
  const base = getFilterObject(data, realMaxValues, realMinValues);
  const { project: _project, ...rest } = base;
  return { ...rest, project: true, itemsPerProject: 3 };
};
